// Rich content for each service detail page, keyed by service `visual`
export const SERVICE_DETAILS = {
  bbps: {
    slug: "bbps-solutions",
    tagline: "Turn every counter into a bill-payment hub that customers return to daily.",
    stats: [{ v: "20,000+", l: "Billers live" }, { v: "26", l: "Bill categories" }, { v: "< 3s", l: "Bill fetch time" }, { v: "T+0", l: "Commission credit" }],
    features: [
      { icon: "Zap", title: "Instant bill fetch", desc: "Pull exact dues, due-date and customer name straight from the biller before collecting a rupee." },
      { icon: "Layers", title: "One API, every category", desc: "Electricity, water, gas, DTH, broadband, insurance, loan EMI, FASTag and municipal taxes on a single integration." },
      { icon: "BadgeCheck", title: "BBPS-assured receipts", desc: "Every payment carries a Bharat Bill Pay reference number customers can verify anywhere." },
      { icon: "IndianRupee", title: "Earn on every bill", desc: "Category-wise commissions credited to your wallet the moment a payment succeeds." },
      { icon: "RefreshCcw", title: "Auto status & refunds", desc: "Pending payments are re-checked automatically; failures are reversed without a support ticket." },
      { icon: "MessageSquare", title: "Complaint desk built in", desc: "Raise and track BBPS disputes from your dashboard with full timeline visibility." },
    ],
    steps: [
      { t: "Pick a biller", d: "Search by category, state or name." },
      { t: "Fetch the bill", d: "Enter consumer number — dues appear instantly." },
      { t: "Collect & pay", d: "Accept cash or UPI, pay from your wallet." },
      { t: "Share receipt", d: "Print or WhatsApp the BBPS-assured receipt." },
    ],
    useCases: [
      { t: "Kirana & mobile shops", d: "Add a daily footfall driver without new inventory." },
      { t: "CSP & BC agents", d: "Offer rural customers a trusted payment point." },
      { t: "Fintech apps", d: "Embed bill pay inside your app with one REST API." },
      { t: "Distributors", d: "Onboard retailers and earn on their volumes." },
    ],
    api: { method: "POST", path: "/v1/bbps/bill/fetch", body: { biller_id: "MSEDCL00MAH01", consumer_no: "170012345678" }, res: { status: "SUCCESS", amount: 1250.0, due_date: "2026-07-24", customer: "R. KUMAR" } },
    faqs: [
      { q: "Which billers are covered?", a: "All billers live on Bharat Bill Payment System, including state electricity boards, gas, water, DTH, broadband, insurance and loan EMIs." },
      { q: "How fast is the commission credited?", a: "Commission is credited to your PhotonPE wallet instantly on every successful payment." },
      { q: "What happens if a payment is pending?", a: "Our system automatically re-checks status and refunds your wallet if the biller does not confirm the payment." },
      { q: "Can I integrate BBPS into my own app?", a: "Yes. Our REST API supports bill fetch, payment, status and complaints with sandbox access for testing." },
    ],
  },
  pos: {
    slug: "pos-solutions",
    tagline: "Rugged Android terminals that accept every payment mode and settle where you want.",
    stats: [{ v: "4-in-1", l: "Card, UPI, Tap, QR" }, { v: "99.5%", l: "Approval rate" }, { v: "48 hrs", l: "Device go-live" }, { v: "24×7", l: "Field support" }],
    features: [
      { icon: "CreditCard", title: "Every payment mode", desc: "Chip, swipe, contactless tap, UPI QR and wallets on a single device." },
      { icon: "Printer", title: "Built-in printer", desc: "Thermal receipts with your shop name and GST details printed instantly." },
      { icon: "LayoutDashboard", title: "Fleet dashboard", desc: "Track every terminal, merchant and transaction across your network in real time." },
      { icon: "Wallet", title: "Flexible settlement", desc: "Settle to bank or to your PhotonPE wallet — instant or scheduled." },
      { icon: "ShieldCheck", title: "PCI-DSS secured", desc: "End-to-end encrypted card data with certified hardware and EMV kernels." },
      { icon: "Wrench", title: "Remote management", desc: "Push updates, lock devices and change settings over the air." },
    ],
    steps: [
      { t: "Apply online", d: "Submit merchant KYC in minutes." },
      { t: "Get the device", d: "Terminal delivered and activated." },
      { t: "Start accepting", d: "Cards, UPI and tap from day one." },
      { t: "Get settled", d: "Money in your bank or wallet." },
    ],
    useCases: [
      { t: "Retail stores", d: "Accept cards without losing walk-in customers." },
      { t: "Restaurants", d: "Bill at the table with mobile terminals." },
      { t: "Distributors", d: "Deploy and manage POS for your retailers." },
      { t: "Field collections", d: "Collect payments on the move with 4G devices." },
    ],
    faqs: [
      { q: "Which cards are supported?", a: "Visa, Mastercard, RuPay and contactless cards, plus UPI QR and major wallets." },
      { q: "How long does activation take?", a: "Once KYC is approved, terminals are typically shipped and live within 48 hours." },
      { q: "Can I manage multiple terminals?", a: "Yes. The fleet dashboard shows every device, merchant and transaction in one place." },
      { q: "Is the terminal secure?", a: "Devices are PCI-DSS certified with encrypted card handling and remote lock." },
    ],
  },
  fastag: {
    slug: "fastag-solutions",
    tagline: "Issue, recharge and manage FASTags for walk-in customers and entire fleets.",
    stats: [{ v: "5 min", l: "Tag issuance" }, { v: "All", l: "NHAI plazas" }, { v: "Bulk", l: "Fleet recharge" }, { v: "Live", l: "Toll alerts" }],
    features: [
      { icon: "Car", title: "Instant issuance", desc: "Issue a new FASTag at your counter with vehicle RC and owner KYC." },
      { icon: "RefreshCcw", title: "Recharge any tag", desc: "Top up FASTags from all issuing banks through NETC recharge." },
      { icon: "Truck", title: "Fleet console", desc: "Manage hundreds of vehicles, wallets and toll spends from one view." },
      { icon: "Bell", title: "Toll alerts", desc: "Real-time notifications for every toll crossing and low balance." },
      { icon: "FileText", title: "Statements & GST", desc: "Vehicle-wise toll reports ready for accounts and GST filing." },
      { icon: "IndianRupee", title: "Earn per tag", desc: "Commission on every issuance and recharge processed." },
    ],
    steps: [
      { t: "Capture details", d: "Vehicle RC and owner KYC." },
      { t: "Issue tag", d: "Map the tag to the vehicle instantly." },
      { t: "Recharge", d: "Load balance from your wallet." },
      { t: "Track", d: "Monitor toll spends in real time." },
    ],
    useCases: [
      { t: "Transport fleets", d: "Central control of all vehicle tolls." },
      { t: "Highway retailers", d: "Serve travellers with instant tags." },
      { t: "Logistics firms", d: "Reconcile toll costs per trip." },
      { t: "Car dealers", d: "Hand over new cars with FASTag fitted." },
    ],
    faqs: [
      { q: "Which documents are needed?", a: "Vehicle RC, owner ID proof and a vehicle photo are required to issue a FASTag." },
      { q: "Can I recharge tags from any bank?", a: "Yes, recharges work for FASTags issued by all NETC member banks." },
      { q: "Is there a fleet option?", a: "The fleet console supports bulk vehicles, wallet allocation and toll reports." },
      { q: "How do I earn?", a: "You earn a commission on every FASTag issued and every recharge processed." },
    ],
  },
  collect: {
    slug: "photon-collect",
    tagline: "Collect via UPI, cards, links and QR — and see every rupee reconciled automatically.",
    stats: [{ v: "UPI + Cards", l: "All payment modes" }, { v: "T+0", l: "Settlement option" }, { v: "98%+", l: "Success rate" }, { v: "Real-time", l: "Webhooks" }],
    features: [
      { icon: "QrCode", title: "Dynamic & static QR", desc: "Amount-locked QR for invoices or one static QR for your counter." },
      { icon: "Link", title: "Payment links", desc: "Send a link on WhatsApp or SMS and get paid in seconds." },
      { icon: "Volume2", title: "Soundbox alerts", desc: "Hear every payment confirmation — no more screenshot fraud." },
      { icon: "GitBranch", title: "Smart routing", desc: "Traffic is routed across banking partners for the highest success rate." },
      { icon: "FileSpreadsheet", title: "Auto reconciliation", desc: "Collections matched to orders and invoices without spreadsheets." },
      { icon: "Webhook", title: "Developer webhooks", desc: "Instant callbacks for success, failure and refunds." },
    ],
    steps: [
      { t: "Create order", d: "Via dashboard or API." },
      { t: "Share QR / link", d: "Customer pays with any app." },
      { t: "Get notified", d: "Webhook + soundbox alert." },
      { t: "Settle", d: "Funds land in your account." },
    ],
    useCases: [
      { t: "E-commerce", d: "Checkout with UPI intent and cards." },
      { t: "Schools & colleges", d: "Fee collection with student mapping." },
      { t: "NBFCs", d: "EMI collection via links and UPI AutoPay." },
      { t: "Retail counters", d: "Static QR with instant sound alerts." },
    ],
    api: { method: "POST", path: "/v1/collect/orders", body: { amount: 2999, purpose: "Order #A1029", customer_mobile: "98XXXXXX10" }, res: { order_id: "COL8F21A9", upi_qr: "upi://pay?pa=photonpe@bank...", status: "CREATED" } },
    faqs: [
      { q: "Which payment modes are supported?", a: "UPI (intent, collect, QR), debit and credit cards, net banking and payment links." },
      { q: "How fast is settlement?", a: "Standard settlement is T+1 with an instant settlement option for eligible businesses." },
      { q: "Do you provide webhooks?", a: "Yes, real-time webhooks for payment success, failure and refunds." },
      { q: "Can I reconcile automatically?", a: "Each collection is tagged to your order or invoice ID and exported in daily statements." },
    ],
  },
  disburse: {
    slug: "photon-disburse",
    tagline: "Send money to any bank account or UPI ID — one at a time or a thousand at once.",
    stats: [{ v: "24×7×365", l: "IMPS & UPI" }, { v: "< 10s", l: "Typical credit" }, { v: "10,000", l: "Rows per bulk file" }, { v: "Auto", l: "Failed-payout refund" }],
    features: [
      { icon: "Send", title: "Multi-rail payouts", desc: "IMPS, NEFT, RTGS and UPI with automatic rail selection by amount and time." },
      { icon: "Upload", title: "Bulk upload", desc: "Pay vendors, agents and staff from a single CSV with row-level status." },
      { icon: "UserCheck", title: "Beneficiary validation", desc: "Penny-drop name match before you send, to stop wrong transfers." },
      { icon: "RotateCcw", title: "Auto refunds", desc: "Failed payouts are reversed to your wallet automatically." },
      { icon: "Activity", title: "Live status", desc: "Track every payout from initiated to credited with UTR numbers." },
      { icon: "Code2", title: "API & webhooks", desc: "Automate payouts from your ERP or app with idempotent APIs." },
    ],
    steps: [
      { t: "Load wallet", d: "Fund your payout balance." },
      { t: "Add beneficiary", d: "Validate account or UPI ID." },
      { t: "Send", d: "Single, bulk or via API." },
      { t: "Track UTR", d: "Live status & statements." },
    ],
    useCases: [
      { t: "Vendor payments", d: "Clear invoices the same day." },
      { t: "Agent commissions", d: "Pay your whole network in one click." },
      { t: "Refunds", d: "Return customer money instantly." },
      { t: "Gig payouts", d: "Daily earnings to delivery partners." },
    ],
    api: { method: "POST", path: "/v1/payouts", body: { amount: 45000, mode: "IMPS", account: "XXXXXX4921", ifsc: "HDFC0001234", ref: "VND-APR-118" }, res: { payout_id: "PO7C1D22", status: "SUCCESS", utr: "414512345678" } },
    faqs: [
      { q: "Do payouts work on holidays?", a: "IMPS and UPI payouts work 24×7, including Sundays and bank holidays." },
      { q: "What if a payout fails?", a: "The amount is automatically refunded to your wallet with the failure reason." },
      { q: "Is there a bulk option?", a: "Yes, upload a CSV of up to 10,000 rows and track each row's status." },
      { q: "Can I verify accounts first?", a: "Penny-drop verification confirms the account holder's name before sending." },
    ],
  },
  vaultpay: {
    slug: "photon-treasury",
    tagline: "A controlled wallet for your entire network — fund, spend, approve and audit in one place.",
    stats: [{ v: "Unlimited", l: "Sub-wallets" }, { v: "1-click", l: "Fund loading" }, { v: "100%", l: "Audit trail" }, { v: "Role-based", l: "Approvals" }],
    features: [
      { icon: "Wallet", title: "Sub-wallets for everyone", desc: "Give each agent, distributor or employee their own controlled balance." },
      { icon: "ArrowDownToLine", title: "Instant funding", desc: "Load money to one wallet or hundreds in seconds." },
      { icon: "Receipt", title: "Invoice on every spend", desc: "Users attach bills and receipts — no more missing proofs." },
      { icon: "SlidersHorizontal", title: "Spend limits", desc: "Daily caps, category rules and approval workflows per user." },
      { icon: "ScrollText", title: "Passbook & statements", desc: "Downloadable ledgers for each wallet with running balances." },
      { icon: "Lock", title: "Maker-checker", desc: "Two-step approvals for large fund movements." },
    ],
    steps: [
      { t: "Create wallets", d: "For each user in your network." },
      { t: "Load funds", d: "From your main treasury." },
      { t: "Users spend", d: "With invoice uploads." },
      { t: "Audit", d: "Every rupee, fully traceable." },
    ],
    useCases: [
      { t: "Distributor networks", d: "Fund retailer float instantly." },
      { t: "Field teams", d: "Controlled expense wallets." },
      { t: "Franchise chains", d: "Central treasury for outlets." },
      { t: "Corporates", d: "Petty cash without the cash." },
    ],
    faqs: [
      { q: "Who can have a wallet?", a: "Any user you add — agents, distributors, employees or customers." },
      { q: "Can I limit spending?", a: "Yes, set daily limits, category rules and approval workflows for each wallet." },
      { q: "How is it audited?", a: "Every load, spend and reversal is logged with user, time and attached invoice." },
      { q: "Can wallets be withdrawn to bank?", a: "Admins can enable withdrawals to verified bank accounts per user role." },
    ],
  },
  eduerp: {
    slug: "photon-edu-erp",
    tagline: "Admissions to alumni — run your school or college on one connected platform.",
    stats: [{ v: "30+", l: "Modules" }, { v: "Online", l: "Fee collection" }, { v: "Parent", l: "Mobile app" }, { v: "Multi", l: "Campus support" }],
    features: [
      { icon: "GraduationCap", title: "Admissions & records", desc: "Online enquiry, admission forms and a complete student profile." },
      { icon: "IndianRupee", title: "Smart fee collection", desc: "Fee structures, instalments, concessions and online payments with auto receipts." },
      { icon: "CalendarCheck", title: "Attendance", desc: "Student and staff attendance with biometric and app support." },
      { icon: "BookOpen", title: "Exams & report cards", desc: "Marks entry, grading rules and printable report cards." },
      { icon: "Bus", title: "Transport & hostel", desc: "Routes, vehicles, hostel rooms and their fees in one place." },
      { icon: "Smartphone", title: "Parent app", desc: "Notices, homework, fees and results on parents' phones." },
    ],
    steps: [
      { t: "Set up campus", d: "Classes, sections, fee plans." },
      { t: "Import data", d: "Students and staff in bulk." },
      { t: "Go digital", d: "Fees, attendance, exams." },
      { t: "Engage parents", d: "Through the mobile app." },
    ],
    useCases: [
      { t: "Schools", d: "K-12 operations and parent engagement." },
      { t: "Colleges", d: "Semester-wise fees and exams." },
      { t: "Coaching institutes", d: "Batches, tests and instalment fees." },
      { t: "Universities", d: "Multi-campus administration." },
    ],
    faqs: [
      { q: "Can parents pay fees online?", a: "Yes, via UPI, cards and net banking with instant digital receipts." },
      { q: "Does it support multiple campuses?", a: "A single login can manage multiple branches with consolidated reports." },
      { q: "Is data migration included?", a: "Our team helps import existing student, staff and fee data." },
      { q: "Is there a mobile app?", a: "Parents, students and teachers each get a dedicated mobile experience." },
    ],
  },
  hrms: {
    slug: "photon-hrms",
    tagline: "Hire, track, pay and retain your people — without a single spreadsheet.",
    stats: [{ v: "1-click", l: "Bulk payroll" }, { v: "PF · ESI · TDS", l: "Statutory ready" }, { v: "Geo", l: "Attendance" }, { v: "Self-service", l: "Employee app" }],
    features: [
      { icon: "UserPlus", title: "Onboarding", desc: "Digital offer letters, document collection and joining checklists." },
      { icon: "MapPin", title: "Attendance & shifts", desc: "Geo-fenced app punch, biometric sync and shift rosters." },
      { icon: "CalendarDays", title: "Leave management", desc: "Custom leave policies with approvals and balances." },
      { icon: "Banknote", title: "Payroll in one click", desc: "Salary calculated from attendance and paid out via Photon Disburse." },
      { icon: "FileCheck", title: "Compliance", desc: "PF, ESI, PT and TDS calculations with ready challans." },
      { icon: "Smartphone", title: "Employee self-service", desc: "Payslips, leave requests and reimbursements on mobile." },
    ],
    steps: [
      { t: "Add employees", d: "Import or invite in bulk." },
      { t: "Track time", d: "Attendance, leaves, shifts." },
      { t: "Run payroll", d: "Auto-calculated salaries." },
      { t: "Pay & file", d: "Disburse and generate challans." },
    ],
    useCases: [
      { t: "SMEs", d: "Replace spreadsheets for 10–500 staff." },
      { t: "Field workforces", d: "Geo attendance for sales teams." },
      { t: "Retail chains", d: "Shift rosters across outlets." },
      { t: "Institutions", d: "Faculty and staff payroll." },
    ],
    faqs: [
      { q: "Is payroll statutory compliant?", a: "Yes, PF, ESI, PT and TDS are calculated automatically as per current rules." },
      { q: "Can salaries be paid directly?", a: "Payroll integrates with Photon Disburse to credit salaries to bank accounts." },
      { q: "Do employees get an app?", a: "Employees can punch attendance, apply leave and download payslips on mobile." },
      { q: "Does it support biometric devices?", a: "Popular biometric devices can sync attendance automatically." },
    ],
  },
  cms: {
    slug: "cash-pickup-deposit",
    tagline: "We collect cash from your shop and credit it to your wallet — tracked at every step.",
    stats: [{ v: "Doorstep", l: "Pickup" }, { v: "Insured", l: "Cash in transit" }, { v: "5-stage", l: "Live tracking" }, { v: "Same day", l: "Wallet credit" }],
    features: [
      { icon: "Truck", title: "Doorstep pickup", desc: "Request a pickup from your retailer portal with a preferred date and slot." },
      { icon: "UserCheck", title: "Verified agents", desc: "Assigned agent name and mobile shared with you before arrival." },
      { icon: "Shield", title: "Insured transit", desc: "Cash moves under insured cash-in-transit cover to the bank." },
      { icon: "Route", title: "5-stage tracking", desc: "Requested → Scheduled → Picked Up → Deposited → Credited, live in your dashboard." },
      { icon: "Wallet", title: "Wallet credit", desc: "Collected amount credited to your PhotonPE wallet, ready for BBPS, payouts and more." },
      { icon: "ScrollText", title: "Digital proof", desc: "Every pickup has a reference number and activity log in your passbook." },
    ],
    steps: [
      { t: "Request pickup", d: "Amount, address, date & slot." },
      { t: "Agent assigned", d: "Name & mobile shared." },
      { t: "Cash collected", d: "Counted at your counter." },
      { t: "Wallet credited", d: "After bank deposit." },
    ],
    useCases: [
      { t: "Retailers & CSPs", d: "Convert daily cash to digital float." },
      { t: "Distributors", d: "Collect from retailers without travel." },
      { t: "Dealers", d: "Safe movement of high cash volumes." },
      { t: "Rural agents", d: "No more trips to the bank branch." },
    ],
    faqs: [
      { q: "How do I request a pickup?", a: "Log in to your retailer portal, open Cash Pickup, enter the amount and pick a date and slot." },
      { q: "When is my wallet credited?", a: "As soon as the cash is deposited in the bank, the collected amount is credited to your wallet." },
      { q: "Can I cancel a request?", a: "Yes, you can cancel any request until an agent has been scheduled." },
      { q: "Is the cash insured?", a: "Cash is moved by verified agents under insured cash-in-transit cover." },
    ],
  },
  verify: {
    slug: "photon-verify",
    tagline: "Verify people, businesses and bank accounts in seconds through simple APIs.",
    stats: [{ v: "25+", l: "Verification APIs" }, { v: "< 2s", l: "Avg. response" }, { v: "98.5%", l: "Match accuracy" }, { v: "Pay-per-use", l: "Pricing" }],
    features: [
      { icon: "IdCard", title: "Identity KYC", desc: "PAN, Aadhaar (OKYC), Voter ID, Driving Licence and Passport verification." },
      { icon: "Building2", title: "Business KYC", desc: "GSTIN, MCA/CIN, Udyam and Shop Act lookups." },
      { icon: "Landmark", title: "Bank verification", desc: "Penny drop and penny-less account validation with name match." },
      { icon: "ScanFace", title: "Face match & liveness", desc: "Selfie-to-ID match with passive liveness detection." },
      { icon: "FileSearch", title: "OCR extraction", desc: "Read details from ID images automatically." },
      { icon: "Gauge", title: "Name match score", desc: "Fuzzy matching across documents to flag mismatches." },
    ],
    steps: [
      { t: "Get API keys", d: "Sandbox in minutes." },
      { t: "Call an API", d: "PAN, bank, GST and more." },
      { t: "Get result", d: "Verified data + match score." },
      { t: "Go live", d: "Pay only per successful call." },
    ],
    useCases: [
      { t: "Lending & NBFC", d: "Faster loan onboarding." },
      { t: "Fintech networks", d: "Verify retailers before activation." },
      { t: "HR teams", d: "Background checks for new hires." },
      { t: "Marketplaces", d: "Seller and vendor onboarding." },
    ],
    api: { method: "POST", path: "/v1/verify/pan", body: { pan: "ABCDE1234F", name: "RAHUL SHARMA" }, res: { status: "VALID", name_match: 98.5, category: "Individual" } },
    faqs: [
      { q: "Which verifications are available?", a: "Identity (PAN, Aadhaar, Voter ID, DL), business (GSTIN, MCA) and bank account verification, plus face match." },
      { q: "How is pricing calculated?", a: "You pay per successful API call from your prepaid wallet." },
      { q: "Is there a sandbox?", a: "Yes, test every API with sample data before going live." },
      { q: "Is the data stored?", a: "Responses are returned to you and not retained beyond regulatory requirements." },
    ],
  },
};

export const slugify = (s) => (s || "").toLowerCase().replace(/&/g, "").replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "");

export const serviceSlug = (s) => SERVICE_DETAILS[s.visual]?.slug || slugify(s.label);
